<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.112.112h19.776v19.776H.112V.112z" />
    <path
      d="M13.582 8.182c-1.648.185-3.802.308-5.344.984-1.78.77-3.03 2.337-3.03 4.644 0 2.953 1.86 4.43 4.253 4.43 2.02 0 3.126-.478 4.686-2.066.516.747.685 1.11 1.63 1.894.21.114.482.103.67-.066l.007.006c.567-.505 1.6-1.4 2.18-1.888.23-.188.19-.496.01-.754-.52-.718-1.073-1.303-1.073-2.634V8.305c0-1.876.133-3.6-1.25-4.89C15.23 2.368 13.423 2 12.04 2 9.336 2 6.318 3.01 5.686 6.35c-.068.356.19.543.423.595l2.753.298c.258-.013.445-.266.494-.523.236-1.15 1.2-1.706 2.284-1.706.585 0 1.25.215 1.596.738.398.584.346 1.384.346 2.06v.37zm-.533 5.906c-.452.8-1.17 1.29-1.968 1.29-1.09 0-1.728-.83-1.728-2.06 0-2.42 2.17-2.86 4.227-2.86v.615c.002 1.108.028 2.03-.53 3.015zm7.633 5.25C18.33 21.077 14.917 22 11.98 22c-4.12 0-7.827-1.522-10.633-4.057-.22-.2-.024-.47.24-.317 3.028 1.762 6.772 2.823 10.64 2.823 2.608 0 5.476-.542 8.115-1.66.397-.17.73.26.34.55zm.653 1.705c-.194.163-.38.076-.293-.14.284-.71.92-2.297.62-2.683-.302-.386-1.99-.183-2.75-.092-.23.027-.266-.173-.06-.32 1.35-.945 3.556-.672 3.812-.355.26.32-.066 2.533-1.33 3.59z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
